import { InfoCircle } from 'flowbite-react-icons/outline'

/**
 * Informational banner shown when a report's guidance classification is
 * inconclusive (`uncertain` / `inconclusive`). It surfaces the API's
 * `classificationExplanation` so the provider understands why the result is not
 * a conclusive diagnostic finding. Rendered on the guidance page alongside (or
 * in place of) finalized guidance.
 */
export function InconclusiveGuidanceBanner({ explanation }: { explanation: string }) {
  return (
    <div
      className="flex w-full gap-4 rounded-base border border-[var(--colors-border-border-warning-subtle,#FDBA8C)] bg-[var(--colors-background-bg-warning-soft,#FFF8F1)] p-4"
      role="status"
      aria-live="polite"
    >
      <InfoCircle className="mt-0.5 h-5 w-5 shrink-0 text-[var(--colors-text-text-fg-warning,#B43403)]" />
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <p className="text-sm font-semibold uppercase leading-5 tracking-tight text-[var(--colors-text-text-fg-warning,#B43403)]">
          Inconclusive
        </p>
        <p className="whitespace-normal break-words text-sm font-normal leading-5 text-[var(--colors-text-text-fg-warning,#B43403)]">
          {explanation}
        </p>
      </div>
    </div>
  )
}

export default InconclusiveGuidanceBanner
